module.exports = __webpack_public_path__ + "static/media/thig_logo@2x.d6d667e7.png";